// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MainLayout_wrapper__2fNK0","middle":"MainLayout_middle__K-OQI","sideMenuWrapper":"MainLayout_sideMenuWrapper__1oJ9g"};